import { RolesEnum } from '../enums/roles.enum';

export class Permissions {
  roles: string[] = [];
  permissions: string[] = [];

  checkPermission(permissions: string[]) {
    const isAdmin = this.roles.find((role) => role === RolesEnum.Admin);

    if (isAdmin) {
      return true;
    }

    const hasIt = permissions.some((permission) => {
      const hasRole = this.roles.some((role) => role === permission);

      const hasPermission = this.permissions.some(
        (role) => role === permission
      );
      return hasRole || hasPermission;
    });

    return hasIt;
  }
}
